var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotSeeIcon = function SvgNotSeeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.048 5.286 3.145 3.145a1.875 1.875 0 0 1 2.376 2.376l3.023 3.023a.833.833 0 0 1-1.179 1.179l-3.023-3.023A1.875 1.875 0 0 1 8.014 9.61L4.87 6.464a.833.833 0 1 1 1.179-1.178Z",
    fill: "#8E939F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.05 7.477 6.242 8.67c-.584.418-1.174.931-1.768 1.54l.151.152c1.859 1.852 3.652 2.764 5.375 2.764.216 0 .434-.014.652-.043l1.394 1.394c-.681.21-1.363.316-2.046.316-2.52 0-5.022-1.431-7.509-4.276l-.265-.308.308-.356C3.37 8.9 4.21 8.108 5.05 7.477ZM10 5.625l.151.002c2.468.056 4.92 1.486 7.358 4.273l.265.308-.116.136c-.98 1.144-1.963 2.068-2.949 2.771l-1.197-1.199.23-.158c.589-.42 1.183-.936 1.784-1.55l-.151-.152C13.516 8.203 11.723 7.292 10 7.292c-.335 0-.671.034-1.01.103l-1.351-1.35.3-.101A7.003 7.003 0 0 1 10 5.625Z",
    fill: "#8E939F",
    fillRule: "nonzero"
  }))));
};
export default SvgNotSeeIcon;